<template>
  <div class="message_panel" :class="[arrowDirection=='right'?'arrow_right':'arrow_left']">
    <div class="panel_box">
      <slot name="content"></slot>
      <div class="panel_arrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfMessagePanel",
  ctrlCaption: "历史提交",
  data() {
    return {

    }
  },
  props: {
    arrowDirection: {
      type: String,
      default: 'right'
    }
  }
}
</script>

<style>
</style>